import { ROUTES } from "utils/routes";

export const ROUTE_TO_TITLE = {
  /* AUTH */
  [ROUTES.AUTH.HOME]: "Kinesin Health",
  [ROUTES.AUTH.LOGIN]: "Login",
  [ROUTES.AUTH.LOGOUT]: "Logout",
  [ROUTES.AUTH.REGISTRATION]: "Registration",
  [ROUTES.AUTH.FORGOT_PASSWORD]: "Forgot Password",
  "/reset_password": "Reset Password",
  [ROUTES.AUTH.SUCCESS_MSG]: "Success",
  [ROUTES.AUTH.SIGNUP]: "Sign Up",
  [ROUTES.AUTH.SIGNUP_TWO]: "Sign Up",
  [ROUTES.AUTH.SIGNUP_THREE]: "Sign Up",
  [ROUTES.AUTH.SIGNUP_FOUR]: "Sign Up",
  [ROUTES.AUTH.SIGNUP_FIVE]: "Sign Up",
  [ROUTES.AUTH.SIGNUP_SIX]: "Sign Up",
  [ROUTES.AUTH.VIDEO_CALL]: "Video Call",
  [ROUTES.AUTH.PARTICIPANT_VIDEO_JOIN]: "Join Video Call",

  /* GLOBAL */
  [ROUTES.GLOBAL.HOME]: "Kinesin Health",
  [ROUTES.GLOBAL.PATIENT]: "Patients",
  [ROUTES.GLOBAL.REPORTS]: "Reports",
  [ROUTES.GLOBAL.CDM_FINDERS]: "CDM Finders",
  "/cdm-finders/cdm-finder": "CDM Finders",
  "/cdm-finders/cdm-recall": "CDM Finders",
  "/cdm-finders/cdm-register": "CDM Finders",
  [ROUTES.GLOBAL.RESULTS]: "Results",
  [ROUTES.GLOBAL.IMMUNIZATIONS]: "Immunisations",
  [ROUTES.GLOBAL.DOCUMENTS]: "Documents",
  [ROUTES.GLOBAL.COMMUNICATIONS]: "Communications",
  [ROUTES.GLOBAL.APPOINTMENTS]: "Appointments",

  [ROUTES.GLOBAL.PAYMENTS]: "Payments",

  /* PATIENT */
  [ROUTES.PATIENT.DETAILS]: "Patient Details",
  [ROUTES.PATIENT.PREGNANCY]: "Patient Pregnancy",
  [ROUTES.PATIENT.CDM]: "Chronic Disease Management",
  [ROUTES.PATIENT.REFERRALS]: "Patient Referrals",
  [ROUTES.PATIENT.DOCUMENTS]: "Patient Documents",
  [ROUTES.PATIENT.COMMUNICATION]: "Patient Communications",
  [ROUTES.PATIENT.PAYMENTS]: "Patient Payments",
  [ROUTES.PATIENT.MEDICATION]: "Patient Medications",
  [ROUTES.PATIENT.CONSULT]: "Patient Consultation",
  [ROUTES.PATIENT.CONSULTATIONS]: "Patient Consultations",
  "/patient/consultation/edit": "Edit Consultation",
  [ROUTES.PATIENT.FAMILY]: "Patient Family",
  [ROUTES.PATIENT.RESULTS]: "Patient Results",
  [ROUTES.PATIENT.IMMUNIZATIONS]: "Patient Immunizations",

  /* SETTINGS */
  [ROUTES.SETTINGS.ROOT]: "Settings - Practice Details",
  [ROUTES.SETTINGS.PRACTICE_DETAILS]: "Settings - Practice Details",
  [ROUTES.SETTINGS.USER_DETAILS]: "Settings - User Management",
  [ROUTES.SETTINGS.SERVICE_DETAILS]: "Settings - Service Details",
  [ROUTES.SETTINGS.DRUGS_FILE]: "Settings - Drugs File",
  [ROUTES.SETTINGS.DOCUMENT_TYPES]: "Settings - Document Types",
  [ROUTES.SETTINGS.VACCINES]: "Settings - Vaccines",
  [ROUTES.SETTINGS.PRACTICE_HOURS]: "Settings - Practice Opening Hours",
  [ROUTES.SETTINGS.SMS_SETTINGS]: "Settings - Sms Templates",
  [ROUTES.SETTINGS.CONSULTATION_TEMPLATES]:
    "Settings - Consultation Notes Templates",
  [ROUTES.SETTINGS.LETTER_TEMPLATES]: "Settings - Letter Templates",
  [ROUTES.SETTINGS.PRACTICE_SETTINGS]: "Settings - Practice Settings",
  [ROUTES.SETTINGS.EMAIL_TEMPLATES]: "Settings - Email Templates",
  [ROUTES.SETTINGS.PAYMENTS_DETAILS]: "Settings - Payments",
  [ROUTES.SETTINGS.HEADERS_FOOTERS]: "Settings - Document Header and Footer",
  [ROUTES.SETTINGS.HEALTHLINK]: "Settings - Healthlink",
  [ROUTES.SETTINGS.MOBILE_APP]: "Settings - Mobile App",
  [ROUTES.SETTINGS.MERGE_PATIENTS]: "Settings - Merge Patient Records",
  [ROUTES.SETTINGS.PROFILE]: "Profile Settings",
  [ROUTES.SETTINGS.TIMEOFF]: "Time Off",
  [ROUTES.SETTINGS.SETTINGS]: "Settings",
};

export const DEFAULT_TITLE = "Kinesin Health";

export const getTitleFromPath = (pathname) => {
  const normalized = pathname.replace(/\/$/, "") || "/";
  if (ROUTE_TO_TITLE[normalized]) return ROUTE_TO_TITLE[normalized];
  const entries = Object.entries(ROUTE_TO_TITLE).sort(
    (a, b) => b[0].length - a[0].length
  );
  const match = entries.find(
    ([route]) => normalized === route || normalized.startsWith(`${route}/`)
  );
  return match?.[1] ?? DEFAULT_TITLE;
};
